/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Assigned_OptionInputs */

const en_insert_speaker_assigned_option = /** @type {(inputs: Insert_Speaker_Assigned_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Assigned Speaker*`)
};

const fr_insert_speaker_assigned_option = /** @type {(inputs: Insert_Speaker_Assigned_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Locuteur assigné*`)
};

const de_insert_speaker_assigned_option = /** @type {(inputs: Insert_Speaker_Assigned_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Zugewiesener Sprecher*`)
};

const it_insert_speaker_assigned_option = /** @type {(inputs: Insert_Speaker_Assigned_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Relatore assegnato*`)
};

const ru_insert_speaker_assigned_option = /** @type {(inputs: Insert_Speaker_Assigned_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Назначенный докладчик*`)
};

const es_insert_speaker_assigned_option = /** @type {(inputs: Insert_Speaker_Assigned_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Orador asignado*`)
};

const zh_cn2_insert_speaker_assigned_option = /** @type {(inputs: Insert_Speaker_Assigned_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*指定发言人*`)
};

const ja_insert_speaker_assigned_option = /** @type {(inputs: Insert_Speaker_Assigned_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*担当スピーカー*`)
};

const hi_insert_speaker_assigned_option = /** @type {(inputs: Insert_Speaker_Assigned_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*नियुक्त वक्ता*`)
};

const pt_pt2_insert_speaker_assigned_option = /** @type {(inputs: Insert_Speaker_Assigned_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Palestrante designado*`)
};

/**
* | output |
* | --- |
* | "*Assigned Speaker*" |
*
* @param {Insert_Speaker_Assigned_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_assigned_option = /** @type {((inputs?: Insert_Speaker_Assigned_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Assigned_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_speaker_assigned_option(inputs)
	if (locale === "de") return de_insert_speaker_assigned_option(inputs)
	if (locale === "it") return it_insert_speaker_assigned_option(inputs)
	if (locale === "ru") return ru_insert_speaker_assigned_option(inputs)
	if (locale === "es") return es_insert_speaker_assigned_option(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_speaker_assigned_option(inputs)
	if (locale === "ja") return ja_insert_speaker_assigned_option(inputs)
	if (locale === "hi") return hi_insert_speaker_assigned_option(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_speaker_assigned_option(inputs)
	return en_insert_speaker_assigned_option(inputs)
});